const products = [
  {
    id: 'vpn',
    name: 'ADDON VPN',
    category: 'Privacy & Security',
    tagline: 'Your Digital Shield',
    description:
      'A powerful VPN solution for iOS that encrypts your internet connection, hides your IP address, and keeps your online activity private. Designed for speed and reliability across global servers.',
    features: ['Military-grade encryption', 'Zero-log policy', 'Global server network', 'One-tap connection', 'Kill switch protection'],
    image: 'https://public.readdy.ai/ai/img_res/74a6fdefb859730b21baa43e8c043f26.jpg',
    accent: 'from-emerald-500 to-teal-600',
    iconBg: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
    icon: 'ri-shield-keyhole-line',
  },
  {
    id: 'cleaner',
    name: 'ADDON Cleaner',
    category: 'Performance & Optimization',
    tagline: 'Speed Up Your iPhone',
    description:
      'An intelligent iOS cleaner that removes junk files, duplicate photos, and unnecessary data to free up storage space and boost your device performance — all with a clean, intuitive interface.',
    features: ['Smart junk detection', 'Duplicate photo finder', 'Storage analyzer', 'Contact cleaner', 'Memory booster'],
    image: 'https://readdy.ai/api/search-image?query=modern%20iPhone%20cleaner%20app%20interface%2C%20bright%20clean%20UI%20with%20storage%20optimization%20charts%2C%20soft%20white%20and%20light%20gray%20tones%2C%20minimalist%20product%20mockup%20on%20clean%20background%2C%20professional%20app%20screenshot%20style&width=600&height=700&seq=cleaner-product-001&orientation=portrait',
    accent: 'from-sky-500 to-indigo-600',
    iconBg: 'bg-sky-50',
    iconColor: 'text-sky-600',
    icon: 'ri-speed-up-line',
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <span
            className="inline-block text-xs font-semibold tracking-widest uppercase text-emerald-600 mb-4"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Our Products
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-5"
            style={{ fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '-0.02em' }}
          >
            iOS Apps That Make
            <br />a Real Difference
          </h2>
          <p
            className="text-gray-500 text-lg max-w-xl mx-auto leading-relaxed"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Each product is carefully engineered to solve real problems for iOS users — from privacy protection to device optimization.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {products.map((product) => (
            <article
              key={product.id}
              className="group rounded-3xl overflow-hidden border border-gray-100 bg-gray-50/50 hover:bg-white transition-all duration-300"
              style={{ boxShadow: 'none' }}
            >
              {/* Image */}
              <div className="relative h-72 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${product.accent} opacity-30`}></div>
                <div className="absolute top-5 left-5">
                  <span
                    className="bg-white/90 backdrop-blur-sm text-gray-700 text-xs font-semibold px-4 py-2 rounded-full"
                    style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                  >
                    {product.category}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${product.iconBg}`}>
                    <i className={`${product.icon} text-xl ${product.iconColor}`}></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 font-medium uppercase tracking-wider" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                      {product.tagline}
                    </p>
                    <h3
                      className="text-xl font-bold text-gray-900"
                      style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                    >
                      {product.name}
                    </h3>
                  </div>
                </div>

                <p
                  className="text-gray-500 text-sm leading-relaxed mb-6"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {product.description}
                </p>

                {/* Features */}
                <ul className="flex flex-wrap gap-2">
                  {product.features.map((feature) => (
                    <li
                      key={feature}
                      className="flex items-center gap-1.5 bg-white border border-gray-200 rounded-full px-3 py-1.5 text-xs text-gray-600 font-medium"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      <i className="ri-check-line text-emerald-500 text-xs"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
